// 电费缴费——微信，主流程
const wxMainRoutes = Array.from({ length: 18}, (_, i) => ({
  path: `electricity/wx/index${i + 1}`,
  name: `electricityWxIndex${i + 1}`,
  component: () => import(`@/views/life/electricity/wx/index${i + 1}.vue`)
}))

// 电费缴费——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 18}, (_, i) => ({
  path: `electricity/zfb/index${i + 1}`,
  name: `electricityZfbIndex${i + 1}`,
  component: () => import(`@/views/life/electricity/zfb/index${i + 1}.vue`),
}));

// 电费缴费——支付宝，分支
const zfbBranchRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `electricity/zfb/branch/index${i + 1}`,
  name: `electricityZfbBranchIndex${i + 1}`,
  component: () =>
    import(`@/views/life/electricity/zfb/branch/index${i + 1}.vue`),
}));

export default {
  path: '/life',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 电费缴费——微信，开始
    ...wxMainRoutes,

    // 电费缴费——支付宝，主流程
    ...zfbMainRoutes,

    // 电费缴费——支付宝，分支
    ...zfbBranchRoutes,
  ]
}
